<template>
  <div class="settings">
    <el-card>
      <div slot="header">
        <span>系统设置</span>
      </div>
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="基本设置" name="basic">
          <el-form ref="basicForm" :model="basicForm" label-width="120px" style="margin-top: 20px;">
            <el-form-item label="系统名称">
              <el-input v-model="basicForm.systemName"></el-input>
            </el-form-item>
            <el-form-item label="自动刷新时间">
              <el-select v-model="basicForm.refreshInterval">
                <el-option label="10秒" value="10"></el-option>
                <el-option label="30秒" value="30"></el-option>
                <el-option label="1分钟" value="60"></el-option>
                <el-option label="5分钟" value="300"></el-option>
                <el-option label="关闭自动刷新" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="告警声音提醒">
              <el-switch v-model="basicForm.alertSound"></el-switch>
            </el-form-item>
            <el-form-item label="告警邮件通知">
              <el-switch v-model="basicForm.alertEmail"></el-switch>
            </el-form-item>
            <el-form-item label="通知邮箱" v-if="basicForm.alertEmail">
              <el-input v-model="basicForm.notificationEmail"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveBasicSettings">保存设置</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        
        <el-tab-pane label="阈值设置" name="thresholds">
          <el-table :data="thresholds" border style="margin-top: 20px;">
            <el-table-column prop="deviceType" label="设备类型" width="180"></el-table-column>
            <el-table-column prop="param" label="参数名称"></el-table-column>
            <el-table-column prop="minValue" label="最小值">
              <template slot-scope="scope">
                <el-input-number 
                  v-model="scope.row.minValue" 
                  :precision="scope.row.precision"
                  :step="scope.row.step"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="maxValue" label="最大值">
              <template slot-scope="scope">
                <el-input-number 
                  v-model="scope.row.maxValue" 
                  :precision="scope.row.precision"
                  :step="scope.row.step"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位"></el-table-column>
          </el-table>
          <div style="margin-top: 15px; text-align: right;">
            <el-button type="primary" @click="saveThresholdSettings">保存阈值设置</el-button>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="用户管理" name="users">
          <div style="margin-bottom: 15px;">
            <el-button type="primary" icon="el-icon-plus" @click="addUser">添加用户</el-button>
          </div>
          <el-table :data="users" border>
            <el-table-column prop="username" label="用户名"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="role" label="角色">
              <template slot-scope="scope">
                <el-tag :type="scope.row.role === 'admin' ? 'primary' : 'success'">
                  {{ scope.row.role === 'admin' ? '管理员' : '操作员' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="editUser(scope.row)">编辑</el-button>
                <el-button size="mini" type="text" style="color: #f56c6c;" @click="deleteUser(scope.row.username)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data() {
    return {
      activeTab: 'basic',
      basicForm: {
        systemName: '物联网管理平台',
        refreshInterval: '30',
        alertSound: true,
        alertEmail: true,
        notificationEmail: 'admin@example.com'
      },
      thresholds: [
        {
          deviceType: '温度传感器',
          param: '温度',
          minValue: 10,
          maxValue: 30,
          unit: '°C',
          precision: 1,
          step: 0.5
        },
        {
          deviceType: '湿度传感器',
          param: '湿度',
          minValue: 30,
          maxValue: 70,
          unit: '%',
          precision: 0,
          step: 1
        },
        {
          deviceType: '烟雾报警器',
          param: '烟雾浓度',
          minValue: 0,
          maxValue: 0.1,
          unit: 'mg/m³',
          precision: 2,
          step: 0.01
        }
      ],
      users: [
        {
          username: 'admin',
          name: '系统管理员',
          role: 'admin',
          status: true
        },
        {
          username: 'operator1',
          name: '操作员一',
          role: 'operator',
          status: true
        },
        {
          username: 'operator2',
          name: '操作员二',
          role: 'operator',
          status: false
        }
      ]
    }
  },
  methods: {
    saveBasicSettings() {
      this.$message.success('基本设置保存成功')
    },
    saveThresholdSettings() {
      this.$message.success('阈值设置保存成功')
    },
    addUser() {
      this.$message.success('添加用户功能待实现')
    },
    editUser(user) {
      this.$message.info(`编辑用户 ${user.username}`)
    },
    deleteUser(username) {
      if (username === 'admin') {
        this.$message.error('不能删除管理员账户')
        return
      }
      
      this.$confirm(`确定要删除用户 ${username} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.users = this.users.filter(user => user.username !== username)
        this.$message.success('用户删除成功')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>
